import styled from "styled-components";

const theme = {
  sungsim: {
    ref: { base: "#2a3341", hover: "#4f78b8" },
    room: { base: "#FFE072", hover: "#ff8a00" },
    car: { base: "#cdb5f5", hover: "#a976ff" },
  },
  baseball: {
    ref: { base: "#FFCC00", hover: "#fff8de" },
    room: { base: "#253f85", hover: "#8ca5e7" },
    car: { base: "#b24d4d", hover: "#f4a5a5" },
  },
};

export const Tab = styled.ul`
  &.baseball li {
    &.refrigerated {
      background: ${theme.baseball.ref.base};
    }
    &.roomTemperature {
      color: #fff;
      background: ${theme.baseball.room.base};
    }
    &.carrier {
      color: #fff;
      background: ${theme.baseball.car.base};
    }
  }
  &.sungsim li {
    &.refrigerated {
      color: #fff;
      background: ${theme.sungsim.ref.base};
    }
    &.roomTemperature {
      background: ${theme.sungsim.room.base};
    }
    &.carrier {
      background: ${theme.sungsim.car.base};
    }
  }
  display: flex;
  align-items: center;
  font-size: 40px;
  height: 80px;
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(100% / 3);
    height: 100%;
    background: #d9d9d9;
    color: #4d4d4d;
    text-align: center;
    font-weight: 700;
    transition: 0.3s;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  @media screen and (max-width: 1050px) {
    font-size: 30px;
    height: 60px;
  }
  @media screen and (max-width: 767px) {
    font-size: 20px;
    height: 48px;
  }
`;

export const KioskStorage = styled.div`
  padding: 20px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  user-select: none;
  .content {
    height: calc(100% - 350px);
  }
  @media screen and (max-width: 1050px) {
    .content {
      height: calc(100% - 280px);
    }
  }
  @media screen and (max-width: 767px) {
    .content {
      height: calc(100% - 200px);
    }
  }
`;

export const ViewAllContainer = styled.div`
  &.sungsim {
    .refrigerated .index {
      color: #fff;
      background: ${theme.sungsim.ref.base};
      &:hover {
        background: ${theme.sungsim.ref.hover};
      }
    }
    .roomTemperature .index {
      background: ${theme.sungsim.room.base};
      &:hover {
        color: #fff;
        background: ${theme.sungsim.room.hover};
      }
    }
    .carrier .index {
      background: ${theme.sungsim.car.base};
      &:hover {
        color: #fff;
        background: ${theme.sungsim.car.hover};
      }
    }
  }

  &.baseball {
    .refrigerated .index {
      background: ${theme.baseball.ref.base};
      &:hover {
        background: ${theme.baseball.ref.hover};
      }
    }
    .roomTemperature .index {
      color: #fff;
      background: ${theme.baseball.room.base};
      &:hover {
        background: ${theme.baseball.room.hover};
      }
    }
    .carrier .index {
      color: #fff;
      background: ${theme.baseball.car.base};
      &:hover {
        background: ${theme.baseball.car.hover};
      }
    }
  }

  .section {
    max-width: 90%;
    height: 100%;
    position: relative;
    margin: auto;
  }
  .swiper-slide {
    padding: 0 10px;
  }
  .slide {
    height: calc(100% - 84px);
    margin-bottom: 30px;
    position: relative;
    .slideWrapper {
      overflow: hidden;
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      .slideContent {
        flex: 0 0 100%;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        transition: 0.5s;
        table {
          width: 100%;
          height: 100%;
          border-collapse: collapse;
          td {
            height: 10%;
            border: 2px solid #fff;
            .index {
              width: 100%;
              height: 100%;
              position: relative;
              font-weight: 700;
              border-radius: 5px;
              font-size: 13px;
              transition: 0.3s;
            }
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
            &.empty .index {
              background: #a7a7a7;
              color: #fff;
            }
            &.locked {
              opacity: 0.5;
            }
            &.paused {
              .index {
                position: relative;
                &::after {
                  content: "X";
                  font-size: 20px;
                  position: absolute;
                  max-width: 100%;
                  max-height: 100%;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  color: #c40000;
                }
              }
            }
          }
        }
      }
    }
    button {
      width: 5%;
      aspect-ratio: 1;
      max-width: 100px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      background: transparent;
      color: #b3b3b3;
      display: flex;
      align-items: center;
      justify-content: center;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: contain;
      &.prev {
        left: 0;
        transform: translate(-100%, -50%);
        background-image: url("/img/arrow_left.png");
      }
      &.next {
        right: 0;
        transform: translate(100%, -50%);
        background-image: url("/img/arrow_right.png");
      }
    }
  }
  .page {
    font-size: 44px;
    font-weight: 700;
    padding: 0 10px;
  }
  .slide .slideWrapper .slideContent table td.hover {
    .index:hover {
      transform: scale(1.2);
      z-index: 22;
    }
  }
  @media screen and (max-width: 1050px) {
    .section {
      max-width: 80%;
      .slide {
        button {
          width: 10%;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .slide {
      height: calc(100% - 60px);
      margin-bottom: 20px;
    }
    .page {
      font-size: 30px;
    }
  }
`;

export const ViewDetailsContainer = styled.div`
  &.baseball {
    table .refrigerated {
      background-color: ${theme.baseball.ref.base};
      &:hover {
        background-color: ${theme.baseball.ref.hover};
      }
    }
    table .roomTemperature {
      color: #fff;
      background-color: ${theme.baseball.room.base};
      &:hover {
        background-color: ${theme.baseball.room.hover};
      }
    }
    table .carrier {
      color: #fff;
      background-color: ${theme.baseball.car.base};
      &:hover {
        background-color: ${theme.baseball.car.hover};
      }
    }
  }
  &.sungsim {
    table .refrigerated {
      color: #fff;
      background-color: ${theme.sungsim.ref.base};
      &:hover {
        background-color: ${theme.sungsim.ref.hover};
      }
    }
    table .roomTemperature {
      background-color: ${theme.sungsim.room.base};
      &:hover {
        color: #fff;
        background-color: ${theme.sungsim.room.hover};
      }
    }
    table .carrier {
      background-color: ${theme.sungsim.car.base};
      &:hover {
        color: #fff;
        background-color: ${theme.sungsim.car.hover};
      }
    }
  }
  .details {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2px 0 10px;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
  }
  table {
    width: 100%;
    border-collapse: collapse;
    border: 3px solid #000;
    .refrigerated {
      .box {
        background-image: url("/img/sungsimdang/sungsimdang_bread_storage.png");
        background-position: 90% 100%;
      }
    }
    .roomTemperature {
      .box {
        background-image: url("/img/sungsimdang/sungsimdang_roomTemperature_storage.png");
        background-position: 90% 90%;
      }
    }
    .carrier {
      .box {
        background-image: url("/img/sungsimdang/sungsimdang_carrier_storage.png");
        background-position: 90% 90%;
      }
    }
    .empty {
      background-color: #dedede;
      .box {
        color: #000;
        font-size: 50px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    td {
      box-sizing: border-box;
      border: 3px solid #000;
      transition: 0.3s;
      width: 10%;
      &.locked {
        opacity: 0.5;
      }
      &.paused {
        .box {
          position: relative;
          &::after {
            content: "X";
            position: absolute;
            top: 50%;
            left: 50%;
            color: #c40000;
            transform: translate(-50%, -50%);
            max-width: 100%;
            max-height: 100%;
            font-weight: bold;
            font-size: 70px;
          }
        }
      }
      .box {
        width: 100%;
        aspect-ratio: 1;
        font-weight: 500;
        font-size: 14px;
        padding: 5px 0 0 5px;
        background-repeat: no-repeat;
        overflow: hidden;
        background-size: 35px 35px;
        span {
          display: block;
          &:nth-child(1),
          &:nth-child(2) {
            font-weight: 700;
          }
        }
      }
    }
  }
  table {
    td:not(.empty):hover {
      transform: scale(1.2);
      z-index: 22;
      border-radius: 10px;
    }
  }

  @media screen and (max-width: 1400px) {
    table td {
      width: 20%;
      .box {
        aspect-ratio: 2 / 1.5;
      }
    }
  }
  @media screen and (max-width: 820px) {
    table td {
      width: calc(100% / 3);
      .box {
        font-size: 12px;
        aspect-ratio: 1;
      }
      &.empty .box {
        font-size: 30px;
      }
    }
  }
`;

export const UserInfoModalContainer = styled.div`
  position: fixed;
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  .modal {
    position: absolute;
    max-width: 900px;
    height: 700px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border: 1px solid #a6a6a6;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-size: 40px;
    border-radius: 50px;
    box-sizing: border-box;
    font-weight: 700;
    overflow: hidden;
    width: 100%;
    .modalContent {
      position: relative;
      width: 100%;
      height: 100%;
      padding: 50px;
      .userInfo {
        width: 100%;
        height: 100%;
        ul {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
        }
      }
      button {
        position: absolute;
        top: 2vw;
        right: 2vw;
        border: none;
        background: transparent;
        display: flex;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .modal {
      width: 90%;
      height: auto;
      max-width: none;
      font-size: 24px;
      border-radius: 20px;
      .modalContent {
        padding: 20px;
        button {
          top: 20px;
          right: 20px;
          font-size: 30px;
        }
      }
    }
  }
`;

export const UserInfoFormContainer = styled.div`
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  &.baseball {
    .userInfoForm li.paymentMethod .con label input:checked ~ .checkmark {
      background-color: ${theme.baseball.ref.base};
      border: 1px solid ${theme.baseball.ref.base};
    }
    button.submit {
      background: ${theme.baseball.ref.base};
      color: #000;
    }
  }
  &.sungsim {
    .userInfoForm li.paymentMethod .con label input:checked ~ .checkmark {
      background-color: ${theme.sungsim.ref.base};
      border: 1px solid ${theme.sungsim.ref.base};
    }
    button.submit {
      background: ${theme.sungsim.ref.base};
      color: #fff;
    }
  }
  .modal {
    &.confirm {
      height: 700px;
      max-width: 700px;
    }
    &.form {
      height: 700px;
      max-width: 989px;
    }
  }
  .slideWrapper {
    flex-flow: row nowrap;
    display: flex;
    flex: 1;
    width: 100%;
    transition: transform 0.5s ease;
    height: 100%;
    overflow: hidden;
    margin: auto;
  }
  .slideContent {
    flex: 0 0 50%;
    height: 100%;
    position: relative;
    transform: translateX(0);
    flex-basis: 100%;
    flex-shrink: 0;
    transition: 0.3s;
    width: 100%;
  }
  .userInfoForm {
    font-weight: 700;
    height: 100%;
    li {
      display: flex;
      align-items: center;
      font-size: 28px;
      &:not(:last-child) {
        border-bottom: 3px solid #efefef;
        padding-bottom: 10px;
        margin-bottom: 10px;
      }
      .tit {
        width: 160px;
        display: inline-block;
      }
      .con {
        width: calc(100% - 170px);
      }
      label {
        display: flex;
        align-items: center;
        width: 100%;
        input[type="text"],
        input[type="number"] {
          border: none;
          font-weight: 700;
          &:focus {
            box-shadow: none !important;
            border: none !important;
          }
        }
        input[type="text"] {
          width: 100%;
        }
      }
      &.quantity .con {
        display: flex;
        gap: 10px;
        align-items: center;
        .preview {
          color: #bbb;
          display: flex;
          gap: 5px;
          font-weight: 600;
        }
        button {
          border: 2px solid #efefef;
          padding: 0 15px;
          border-radius: 10px;
          font-weight: 700;
        }
      }
      &.storage {
        align-items: flex-start;
        .storageType {
          display: flex;
          gap: 10px;
          width: calc(100% - 170px);
          .box {
            width: calc((100% - 20px) / 3);
            height: 170px;
            display: flex;
            flex-direction: column;
            .bg {
              width: 100%;
              height: 120px;
              border: 3px solid #d4d4d4;
              display: inline-block;
              border-radius: 5px;
              text-align: center;
              background-repeat: no-repeat;
              background-position: 50% 20%;
              background-size: 30%;
              position: relative;
              margin-bottom: 10px;
              &.refrigerated {
                background-image: url("/img/sungsimdang/sungsimdang_refrigerated_storage.png");
              }
              &.roomTemperature {
                background-image: url("/img/sungsimdang/sungsimdang_roomTemperature_storage.png");
              }
              &.carrier {
                background-image: url("/img/sungsimdang/sungsimdang_carrier_storage.png");
              }
              span {
                position: absolute;
                font-size: 22px;
                bottom: 10px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
            .storageNumber {
              width: 100%;
              height: 40px;
              font-size: 20px;
              display: flex;
              align-items: center;
              border: 3px solid #d4d4d4;
              border-radius: 5px;
              font-weight: 700;
              button {
                width: 40px;
                font-size: 20px;
                border: none;
                background: transparent;
                svg {
                  display: block;
                  margin: auto;
                }
              }
              input[type="number"] {
                width: calc(100% - 80px);
                height: 100%;
                border: none !important;
                border-left: 3px solid #d4d4d4 !important;
                border-right: 3px solid #d4d4d4 !important;
                text-align: center;
                &:focus {
                  outline: none;
                  border: none !important;
                  border-left: 3px solid #d4d4d4 !important;
                  border-right: 3px solid #d4d4d4 !important;
                }
                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                  -webkit-appearance: none;
                  margin: 0;
                }
              }
            }
          }
        }
      }
      &.paymentMethod {
        .con {
          display: flex;
          gap: 10px;
          align-items: center;
          label {
            height: 35px;
            width: 35px;
            position: relative;
            input {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              padding: 0;
              width: 0;
              height: 0;
            }
            .checkmark {
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              width: 100%;
              border: 2px solid #d4d4d4;
              border-radius: 10px;
              background-color: transparent;
              transition: all 0.3s ease;
              &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg) scale(0);
                opacity: 0;
                width: 13px;
                height: 24px;
                border: solid #fff;
                border-width: 0px 3px 3px 0px;
                transition: 0.3s;
              }
            }
            input:checked ~ .checkmark {
              &:after {
                opacity: 1;
                transform: translate(-50%, -65%) rotate(45deg) scale(1);
                border-color: #fff;
              }
            }
            &:hover .checkmark {
              background-color: #efefef;
            }
          }
          label + span {
            margin-right: 10px;
          }
        }
      }
    }
  }
  button.submit {
    bottom: 0;
    position: absolute;
    right: 0;
    font-size: 30px;
    background: ${theme.sungsim.ref.base};
    width: 200px;
    height: 50px;
    border-radius: 40px;
    color: #fff;
    z-index: 100;
    border: none;
  }

  @media screen and (max-width: 820px) {
    .modal {
      &.form {
        height: auto;
      }
      &.confirm {
        height: 450px;
        .slideContent:last-child li:last-child {
          max-height: 73px;
        }
      }
      .modalContent {
        button {
          &.submit {
            position: relative;
            bottom: 0;
            right: 0;
            margin-top: 30px;
            margin: 30px auto 0;
            display: block;
            font-size: 20px;
            width: 150px;
            height: 40px;
          }
        }
      }
      button.checkButton {
        width: 100px;
        height: 50px;
        font-size: 20px;
      }
      .userInfoForm {
        padding: 0;
        font-size: 16px;
        li {
          font-size: 16px;
          .con {
            width: calc(100% - 85px);
          }
          &:not(:last-child) {
            padding-bottom: 10px;
            margin-bottom: 10px;
          }
          &.quantity .con {
            width: calc(100% - 85px);
            justify-content: space-between;
            .inquiry {
              padding: 0px 5px;
            }
          }
          input[type="text"] {
            width: 100%;
          }
          input[type="number"] {
            width: 70px;
            margin-right: 5px;
          }
          &.storage {
            flex-wrap: wrap;
            .storageType {
              width: 100%;
              .box {
                height: 150px;
                .bg {
                  background-size: 70% 50% contain;
                }
                .storageNumber {
                  input {
                    width: 100%;
                    border: none !important;
                    margin-right: 0;
                    &:focus {
                      border: none !important;
                    }
                  }
                }
                span {
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ViewTypeContainer = styled.div`
  position: relative;
  &.baseball ul li.active {
    background: ${theme.baseball.ref.base};
  }
  &.sungsim ul li.active {
    color: #fff;
    background: ${theme.sungsim.ref.base};
  }
  ul,
  button {
    height: 66px;
    font-size: 26px;
    font-weight: 700;
    border-radius: 33px;
  }
  ul {
    display: flex;
    align-items: center;
    border: 3px solid #a0a0a0;
    padding: 10px;
    background: #fff;
    width: 250px;
    margin: 0 auto;
    li {
      width: 50%;
      height: 100%;
      border-radius: 35px;
      transition: 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .buttons {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    button {
      background: #333;
      color: #fff;
      border: none;
      padding: 0 20px;
      &:first-child {
        margin-right: 10px;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    ul,
    button {
      height: 50px;
      font-size: 20px;
    }
    ul {
      width: 200px;
      margin: 0;
      padding: 5px;
    }
    .buttons {
      position: relative;
      transform: translate(0);
      top: 0;
      text-align: right;
    }
  }
  @media screen and (max-width: 767px) {
    ul,
    button {
      height: 40px;
      font-size: 16px;
    }
    ul {
      width: 120px;
    }
    .buttons button {
      padding: 0 10px;
    }
  }
`;

export const CustResvContainer = styled.div`
  position: fixed;
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  .modalContent {
    position: relative;
    width: 100%;
    height: 100%;
    .slideWrapper {
      flex-flow: row nowrap;
      display: flex;
      flex: 1;
      width: 100%;
      transition: transform 0.5s ease;
      height: 100%;
      overflow: hidden;
      margin: auto;
    }
    .slideContent {
      flex: 0 0 50%;
      height: 100%;
      position: relative;
      transform: translateX(0);
      flex-basis: 100%;
      flex-shrink: 0;
      transition: 0.3s;
      width: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    .info {
      font-size: 20px;
    }
    .confirm {
      font-size: 20px;
    }
    .close {
      top: 15px;
      right: 15px;
    }
    .reserved {
      height: calc(100% - 145px);
      > li {
        padding: 10px;
      }
    }
  }
`;

export const CustomerListContainer = styled.div`
  .search {
    width: 70%;
    position: relative;
    margin-bottom: 48px;
    input {
      width: 100%;
      border: none;
      border-bottom: 3px solid #000;
      padding: 0 40px 0 0;
      &:focus {
        border: none !important;
        box-shadow: none;
        border-bottom: 3px solid #000 !important;
      }
    }
    button {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      border: none;
      display: flex;
    }
  }
  .customers {
    height: calc(100% - 100px);
    ul {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c1c1c1;
        border: 2px solid #fafafa;
      }
      &::-webkit-scrollbar-track {
        background-color: #fafafa;
        border-radius: 10px;
      }
      &.pickup li {
        .info {
          width: calc(100% - 100px);
        }
        .buttons {
          width: 100px;
          button {
            width: 100%;
            &:last-child {
              margin-left: 0;
            }
          }
        }
      }
      li {
        border-bottom: 3px solid #efefef;
        display: flex;
        font-size: 24px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        padding-bottom: 10px;
        .info {
          width: 75%;
          span {
            display: inline-block;
            &.idx {
              width: 15%;
            }
            &.time {
              width: 35%;
            }
            &.name {
              width: 15%;
            }
            &.tel {
              width: 35%;
            }
          }
        }
        .buttons {
          width: 25%;
          button {
            width: 49%;
            border: none;
            font-size: 20px;
            padding: 5px 0;
            border-radius: 5px;
            font-weight: 700;
            &:last-child {
              margin-left: 2%;
              background: ${theme.sungsim.ref.base};
              color: #fff;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    .customers ul li {
      font-size: 20px;
    }
  }
  @media screen and (max-width: 767px) {
    .search {
      input {
        font-size: 16px;
        padding: 0 25px 0 0;
      }
      button {
        font-size: 25px;
      }
    }
    .customers ul li {
      display: block;
      border: 3px solid rgb(239, 239, 239);
      padding: 10px;
      border-radius: 5px;
      &:nth-child(1) {
        display: none;
      }
      .info {
        width: 100%;
        margin-bottom: 5px;
        span.idx {
          display: block;
          width: auto;
        }
        span.name,
        span.time {
          width: auto;
          margin-right: 10px;
        }
        span.tel {
          width: auto;
        }
      }
      .buttons {
        width: 100%;
        button {
          font-size: 18px;
          width: auto;
          padding: 5px 15px;
        }
      }
    }
  }
`;

export const SaveFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .info {
    font-size: 30px;
  }
  .userInfo {
    margin: 20px 0;
    font-size: 24px;
    li {
      height: 30px;
      display: flex;
      gap: 10px;
      span {
        display: inline-block;
        height: 100%;
        &.con {
          min-width: 50%;
        }
      }
      input[type="text"] {
        border: none;
        border-bottom: 2px solid #000;
        height: calc(100% - 2px);
        width: 100%;
        font-size: 20px;
        &:focus {
          border: none !important;
          border-bottom: 2px solid #000 !important;
          box-shadow: none !important;
        }
      }
    }
  }
  .reserved {
    height: calc(100% - 295px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border: 2px solid #fafafa;
    }
    &::-webkit-scrollbar-track {
      background-color: #fafafa;
      border-radius: 10px;
    }
    > li {
      width: 49%;
      display: inline-block;
      border: 3px solid #000;
      font-size: 20px;
      margin-bottom: 20px;
      padding: 5px;
      border-radius: 10px;
      display: inline-block;
      position: relative;
      &:nth-child(odd) {
        margin-right: 2%;
      }
      &:last-child {
        margin-bottom: 0;
      }
      .reserveInfo {
        width: 90%;
        > li {
          display: flex;
          gap: 10px;
          .tit {
            width: 40%;
          }
          .con {
            width: 60%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .reserved {
      > li {
        width: 100%;
        &:nth-child(odd) {
          margin-right: 0;
        }
        .reserveInfo > li {
          display: block;
          margin-bottom: 5px;
          span.tit,
          span.con {
            font-size: 16px;
          }
          span.tit {
            color: #888;
            width: 100px;
            display: inline-block;
          }
        }
      }
    }
  }
`;

export const OnsitePaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  .onsitePaymentInfo {
    text-align: center;
    strong {
      color: ${theme.sungsim.ref.base};
    }
    span {
      display: block;
    }
  }
  .info {
    text-align: center;
  }
  .paymentMethod {
    .con {
      display: flex;
      align-items: center;
    }
    label {
      display: inline-block;
      height: 35px;
      width: 35px;
      position: relative;
      margin-right: 10px;
      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        padding: 0;
        width: 0;
        height: 0;
      }
      .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        border: 2px solid #d4d4d4;
        border-radius: 10px;
        background-color: transparent;
        transition: all 0.3s ease;
        &:after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg) scale(0);
          opacity: 0;
          width: 13px;
          height: 24px;
          border: solid #fff;
          border-width: 0px 3px 3px 0px;
          transition: 0.3s;
        }
      }
      input:checked ~ .checkmark {
        background: ${theme.sungsim.ref.base};
        border: 1px solid ${theme.sungsim.ref.base};
        &:after {
          opacity: 1;
          transform: translate(-50%, -65%) rotate(45deg) scale(1);
          border-color: #fff;
        }
      }
      &:hover .checkmark {
        background-color: #efefef;
      }
    }
    label + span {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .buttons {
    button {
      width: 200px;
      padding: 10px 0;
      font-size: 35px;
      font-weight: 700;
      border-radius: 10px;
      color: #fff;
      border: none;
      &:first-child {
        margin-right: 10px;
        background: ${theme.sungsim.ref.base};
      }
      &:last-child {
        background: #ccc;
      }
    }
  }
  @media screen and (max-width: 767px) {
    .buttons {
      width: 100%;
      button {
        width: calc(50% - 5px);
      }
    }
  }
`;

export const StorageNumberContainer = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: space-between;
  .storageInfo {
    font-size: 40px;
    font-weight: 700;
    max-height: calc(100% - 120px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #5a5a5a;
      border-radius: 10px;
      border: 2px solid #d9d9d9;
    }
    &::-webkit-scrollbar-track {
      background-color: #d9d9d9;
      border-radius: 10px;
    }
    .label {
      display: block;
      margin: 20px 0;
    }
  }
  .buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    button {
      display: block;
      position: relative;
      font-size: 30px;
      background: ${theme.sungsim.ref.base};
      width: 200px;
      height: 70px;
      border-radius: 10px;
      color: #fff;
      border: none;
      &:not(.checkButton) {
        margin: 0 auto;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .storageInfo {
      font-size: 20px;
    }
    .buttons {
      align-items: center;
      justify-content: center;
      gap: 10px;
      button.checkButton {
        margin: 0;
        font-size: 20px;
        width: 150px;
        height: 40px;
      }
    }
  }
`;

export const StoreSettingsContainer = styled.div`
  position: fixed;
  z-index: 3000;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  &.baseball {
    .modalContent ul li label input:checked ~ .checkmark {
      background-color: ${theme.baseball.ref.base};
      border: 1px solid ${theme.baseball.ref.base};
    }
    .modalContent button.submit {
      background: ${theme.baseball.ref.base};
      color: #000;
    }
  }
  &.sungsim {
    .modalContent ul li label input:checked ~ .checkmark {
      background-color: ${theme.sungsim.ref.base};
      border: 1px solid ${theme.sungsim.ref.base};
    }
    .modalContent button.submit {
      background: ${theme.sungsim.ref.base};
      color: #fff;
    }
  }
  .modalContent {
    .slideWrapper {
      flex-flow: row nowrap;
      display: flex;
      flex: 1;
      width: 100%;
      transition: transform 0.5s ease;
      height: 100%;
      overflow: hidden;
      margin: auto;
    }
    .slideContent {
      flex: 0 0 50%;
      height: 100%;
      position: relative;
      transform: translateX(0);
      flex-basis: 100%;
      flex-shrink: 0;
      transition: 0.3s;
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      &:first-child {
        justify-content: space-between;
      }
      &:nth-child(2) {
        justify-content: center;
        gap: 50px;
      }
    }
    ul {
      width: 100%;
      li {
        display: flex;
        border-bottom: 3px solid #efefef;
        padding-bottom: 10px;
        margin-bottom: 10px;
        &:first-child {
          padding-bottom: 10px;
          margin-bottom: 30px;
        }
        &:last-child {
          margin-top: 30px;
        }
        .tit {
          width: 200px;
        }
        .radioContent {
          width: calc(100% - 200px);
          display: flex;
          align-items: center;
        }
        label {
          height: 35px;
          width: auto;
          position: relative;
          display: flex;
          align-items: center;
          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            padding: 0;
            width: 0;
            height: 0;
          }
          .checkmark {
            position: relative;
            display: inline-block;
            height: 35px;
            width: 35px;
            border: 2px solid #d4d4d4;
            border-radius: 10px;
            background-color: transparent;
            transition: all 0.3s ease;
            margin-right: 10px;
            &:after {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(45deg) scale(0);
              opacity: 0;
              width: 13px;
              height: 24px;
              border: solid #fff;
              border-width: 0px 3px 3px 0px;
              transition: 0.3s;
            }
          }
          input:checked ~ .checkmark {
            &:after {
              opacity: 1;
              transform: translate(-50%, -65%) rotate(45deg) scale(1);
              border-color: #fff;
            }
          }
          &:hover .checkmark {
            background-color: #efefef;
          }
        }
        span.checkmark + span {
          margin-right: 20px;
        }
        &.notice {
          flex-direction: column;
          input[type="text"] {
            border: none !important;
            font-weight: 700;
            margin-top: 5px;
            /* border-bottom: 3px solid #999 !important; */
            &:focus {
              border: none !important;
              box-shadow: none;
              /* border-bottom: 3px solid #999 !important; */
            }
          }
        }
      }
    }
    button.submit {
      display: block;
      position: relative;
      font-size: 30px;
      width: 200px;
      height: 70px;
      border-radius: 10px;
      color: #fff;
      border: none;
    }
  }
  @media screen and (max-width: 767px) {
    .modalContent {
      ul li {
        display: block;
        &:first-child {
          margin-bottom: 20px;
        }
        &:last-child {
          margin-top: 20px;
        }
        .tit {
          display: block;
          width: 100%;
          margin-bottom: 5px;
        }
      }
      button.submit {
        width: 150px;
        height: 40px;
        font-size: 20px;
      }
    }
  }
`;
